<template>
  <div class="games-pending-approval">
    <div
      v-for="(item, ind) in myGamesPendingApproval"
      :id="`game-${item.id}`"
      :key="`${item.id}-${ind}`"
      class="game">
      <AsyncAction :game="item"></AsyncAction>

      <div v-if="item.disabled" class="disabled-game">
        <span>There are ongoing operations</span>
        <span>
          <i class="el-icon-loading"></i>
        </span>
      </div>
      <HeaderCompactStudioGameCard :item="item" @click="gotoGameView(item)"></HeaderCompactStudioGameCard>
      <div v-if="item" class="middle-content pending-approval">
        <div v-if="isLoading(item)" class="wait">
          <i class="el-icon-loading"></i>
        </div>
        <div v-else>
          <div v-if="!canApprove(item)" class="self-approve">
            <div class="left">
              <el-image
                v-if="!unavailableReason(item) || unavailableReason(item)==='PERMISSION_DENIED_ACCEPT_TESTING'"
                class="preview"
                style="width: 30px;
                        height: 30px;
                        margin: 5px;
                        border-radius: 5px;
                        min-width: 30px;"
                :src="roket"
                :fit="'cover'"
                data-test-id="myGamesPendingMessageIcon"
              >
                <div slot="error" class="image-slot">
                  <span><img :src="gameIcon" :width="40"/></span>
                </div>
              </el-image>
              <el-image
                v-else
                class="preview"
                style="width: 30px;
                        height: 30px;
                        margin: 5px;
                        border-radius: 5px;
                        min-width: 30px;"
                :src="warningIcon"
                :fit="'cover'"
                data-test-id="myGamesPendingMessageIcon"
              >
                <div slot="error" class="image-slot">
                  <span><img :src="gameIcon" :width="40"/></span>
                </div>
              </el-image>
              <div v-if="unavailableReason(item)==='PERMISSION_DENIED_ACCEPT_TESTING'" data-test-id="myGamesPendingMessageText"  class="self-approve">
                <p>{{ displayError(unavailableReason(item)) }}</p>
              </div>
              <div v-else-if="unavailableReason(item)" data-test-id="myGamesPendingMessageText"  class="error">
                <p>{{ displayError(unavailableReason(item)) }}</p>
              </div>
              <p v-else data-test-id="myGamesPendingMessageText" class="self-approve">
                <b>You have completed your testing request successfully!</b>
                <br />Once we accept your request (generally under 1 or 2 business days),
                your marketing campaign will be created and its results will appear in the “In testing” section.
              </p>
            </div>
          </div>
          <div v-else class="self-approve">
            <div class="left">
              <el-image
                class="preview"
                style="width: 30px;
                        height: 30px;
                        margin: 5px;
                        border-radius: 5px;
                        min-width: 30px;"
                :src="roket"
                :fit="'cover'"
                data-test-id="myGamesPendingMessageIcon"
              >
                <div slot="error" class="image-slot">
                  <span><img :src="gameIcon" :width="40"/></span>
                </div>
              </el-image>
              <b>You can approve your game by yourself to start testing campaign:</b>
            </div>
            <div class="action">
              <i v-if="item.loadingAction" class="el-icon-loading"></i>
              <el-button
                type="success"
                data-test-id="pendingApprovalApproveButton"
                @click="action(item, 'accept_testing')">
                Approve
              </el-button>
              <el-button
                type="danger"
                data-test-id="pendingApprovalDeclineButton"
                @click="action(item, 'decline_testing')">
                Decline
              </el-button>
              <el-tooltip placement="top-start" :visible-arrow="false" popper-class="tooltip-game">
                <div slot="content">
                  <div>
                    You may want to decline your testing
                    <br />request in certain circumstances <br />(for example, if you want to upload <br />a new or updated video to
                    your testing <br />campaign prior to launching it)
                  </div>
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          <!-- </div> -->
          </div>
        </div>

      </div>
      <div v-if="item.loadingAction" class="loading-approval">
        <i class="el-icon-loading loading-list"></i>
      </div>
    </div>

    <div v-if="myGamesPendingApproval.length === 0 && !loading" class="no-data">
      <el-image
        class="preview"
        style="
                        width: 40%;
                        padding: 20px;
                        margin: 5px;
                        border-radius: 5px;
                        max-width: 700px;"
        :src="desert"
        :fit="'cover'"
      >
        <div slot="error" class="image-slot">
          <span><img :src="gameIcon" :width="40"/></span>
        </div>
      </el-image>
      <span class="title-no-game">You haven’t submit {{contentType === 'game' ? "a game" : "an app" }} yet!</span>
      <span class="quote-no-game">Start by submitting {{contentType === 'game' ? "a game" : "an app" }} and follow the process here</span>
      <CreateGameButton v-if="contentType === 'game'"></CreateGameButton>
      <CreateAppButton v-if="contentType === 'app'"></CreateAppButton>
    </div>
    <InfiniteLoading ref="InfiniteLoadingPending" @infinite="getMyGames">
      <div slot="spinner" class="spinner">
        <i class="el-icon-loading loading-list" />
      </div>
      <div slot="no-more" class="no-more">No more {{contentType === 'game' ? "games" : "apps" }}</div>
      <div slot="no-results" class="no-more">
        <div class="no-results"></div>
      </div>
    </InfiniteLoading>
  </div>
</template>

<script>
import actionList from '@/static/actionList';
import { cloneDeep } from 'lodash';
import InfiniteLoading from 'vue-infinite-loading';

import desert from '@/assets/images/desert.svg';
import gameIcon from '@/assets/images/icon-dock-placeholder.svg';
import gaImage from '@/assets/images/pic-5-abf-96-e-6-ca-9715-512-x-99048203@3x.png';
import roket from '@/assets/images/roket.png';
import warningIcon from '@/assets/images/warning.svg';
import fbImage from '@/assets/images/x-4-g-0-h-2-ly-400-x-400@2x.png';
import AsyncAction from '@/components/AsyncAction.vue';
import CreateGameButton from '@/components/CreateGameButton.vue';
import HeaderCompactStudioGameCard from '@/components/HeaderCompactGameCard.vue';
import tools from '@/tools/tools';
import CreateAppButton from '@/components/CreateAppButton.vue';

export default {
  name: 'GamePendingApproval',
  components: {
    CreateAppButton,
    HeaderCompactStudioGameCard,
    CreateGameButton,
    InfiniteLoading,
    AsyncAction,
  },
  props: {
    contentType: {
      type: String,
      required: false,
      default: 'game',
    },
  },
  data() {
    return {
      desert,
      gameIcon,
      roket,
      fbImage,
      gaImage,
      actionList,
      warningIcon,
    };
  },
  computed: {
    showGameOnly() {
      return cloneDeep(this.$store.getters['gameAction/showGameOnly']);
    },
    me() {
      return cloneDeep(this.$store.getters['users/me']) || null;
    },
    myGamesPendingApproval() {
      return cloneDeep(this.$store.getters['gameAction/myGames']);
    },
    loading() {
      return cloneDeep(this.$store.getters['gameAction/myGamesLoading']) || false;
    },
    sort() {
      const params = cloneDeep(this.$store.getters['gameAction/params']);
      return params.myGames.sort;
    },
    order() {
      const params = cloneDeep(this.$store.getters['gameAction/params']);
      return params.myGames.order;
    },
    myPermissions() {
      return this.$store.getters['users/myPermissions'];
    },
    codification() {
      return this.$store.getters['users/codification'] || null;
    },
    gamePermissions() {
      return Object.keys(this.game.permissions);
    },
  },
  watch: {
    $route(value, old) {
      if (value.path !== old.path) {
        this.$store.dispatch('gameAction/reset_gameList');
        this.$refs.InfiniteLoadingPending.stateChanger.reset();
      }
    },
    showGameOnly() {
      this.$store.dispatch('gameAction/reset_gameList');
      this.$refs.InfiniteLoadingPending.stateChanger.reset();
    },
    sort() {
      this.$store.dispatch('gameAction/reset_gameList');
      this.$refs.InfiniteLoadingPending.stateChanger.reset();
    },
    order() {
      this.$store.dispatch('gameAction/reset_gameList');
      this.$refs.InfiniteLoadingPending.stateChanger.reset();
    },
  },
  methods: {
    isLoading(game) {
      return !game.actions;
    },
    canApprove(game) {
      if (game.actions) {
        return game.actions.filter(el => !el.unavailableReason).find(el => el.id === 'accept_testing');
      }
      return false;
    },
    unavailableReason(game) {
      if (game.actions) {
        const gamesUnavailable = game.actions.filter(el => el.unavailableReason);
        return gamesUnavailable.find(el => el.id === 'accept_testing') ? gamesUnavailable.find(el => el.id === 'accept_testing').unavailableReason : false;
      }
      return false;
    },
    gotoGameView(item) {
      this.$router
        .push({
          query: {
            game: undefined,
            studio: undefined,
            view: undefined,
            gameid: item.id,
          },
        })
        .catch(() => {});
    },
    displayError(code) {
      return this.codification.errorList[code] ? this.codification.errorList[code].message : code;
    },
    action(game, actionName) {
      const action = this.actionList.filter(el => el.id === actionName)[0];
      const param = {
        id: cloneDeep(game.id),
        action,
      };
      this.$store.dispatch('ActionToDispatch/dispatchAction', param);
    },
    getMyGames($state) {
      this.$store.dispatch('gameAction/getMyGames', {
        loader: $state,
        status: 'pending_approval',
        term: this.$route.query.term || '',
        type: this.$route.params.type || 'cpi',
      });
    },
    show(item) {
      this.$store.dispatch('gameAction/showDetail', item);
      if (item.show === true) {
        window.scroll(0, tools.findPos(document.getElementById(`game-${item.id}`), true));
      }
    },
    getTagsArray(item) {
      return item.split('|');
    },
  },
};
</script>

<style lang="scss">
.load {
  font-size: 30px;
  color: grey;
  margin-top: 70px;
}
.el-tooltip__popper.is-dark.tooltip-game {
  background-color: #82bdf7;
  // .popper__arrow{
  //   border-color:#82bdf7;
  // }
}
.self-approve {
  color: #58c783;
  text-align: left;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  // line-height: 16px;
  line-height: 18px;
    .error{
      color: $orange-alert;
    }
  @media screen and (max-width: 700px) {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }
  b {
    font-size: 12px;
  }
  &:left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  i {
    margin-left: 10px;

    &.el-icon-info {
      color: #e6f1fd;
      font-size: 30px;
    }
  }
  .action {
    display: flex;
    align-items: center;
    .el-icon-loading {
      color: #c2c2c2;
      font-size: 20px;
      margin-right: 10px;
    }
  }
}
.games-list {
  padding: 0px 14px;
  @media (max-width: 700px) {
    padding: 10px 10px;
  }
  .games-pending-approval {
    .game {
      // height: 100px;
      display: flex;
      // position: sticky;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      border-radius: 10px;
      box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
      background-color: #ffffff;
      margin-bottom: 20px;
      position: relative;
      .disabled-game {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 4;
        border-radius: 10px;
        background-color: rgba(201, 224, 246, 0.89);
        // background-color: rgba(130, 189, 247, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #067bf0;
        font-weight: bold;
        span {
          margin-right: 10px;
        }
      }
      .middle-content {
        width: 100%;
        // padding: 30px 10px 20px 10px;
        &.pending-approval {
          padding: 0px;
        }
        .wait {
          padding: 20px;
        }

        .success {
          display: flex;
          justify-content: center;
          padding: 0px;
          color: #58c783;
          i {
            font-size: 30px;
            margin-right: 10px;
          }
        }
        .el-step__head.is-process {
          color: #ffffff;
          border-color: #c5c5c5;
          color: #067bf0;
          border-color: #067bf0;

          .el-step__icon {
            color: #fff;
            background-color: #067bf0;
          }
        }
        .el-step__head.is-success {
          color: #067bf0;
          border-color: #067bf0;

          .el-step__icon {
            color: #fff;
            background-color: #067bf0;
            &:hover {
              cursor: pointer;
            }
          }
        }
        .el-step__title {
          color: #adadad;
          font-size: 12px;
          line-height: 20px;
          &.is-success {
            color: #067bf0;
          }
          &.is-process {
            color: #067bf0;
          }
        }
      }
      .loading-approval {
        padding: 20px;
      }
      .content-page-step {
        width: 100%;
      }
      .bottom-content {
        background-color: #e6f1fd;
        color: #067bf0;
        width: 100%;
        padding: 5px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        &:hover {
          cursor: pointer;
          background-color: #e0eefc;
        }
        span {
          padding: 5px;
          font-size: 10px;
        }
      }
    }
    .no-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title-no-game {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: #82bdf7;
        line-height: 40px;
        @media screen and (max-width: 700px) {
          font-size: 16px;
        }
      }
      .quote-no-game {
        font-size: 15px;
        text-align: center;
        color: #82bdf7;
        margin-bottom: 30px;
        @media screen and (max-width: 700px) {
          font-size: 14px;
        }
      }
    }
  }
  .no-more {
    color: #cbcbcb;
  }
}
</style>
